import type { PropsWithChildren } from 'react';
import { Link, NavLink } from 'react-router-dom';

export function SiteLayout({ children }: PropsWithChildren) {
  return (
    <div className="site-shell">
      <header className="topbar">
        <div className="topbar__inner">
          <Link to="/" className="brand">
            <span className="brand__mark">R</span>
            <span>
              <strong>Rolantir</strong>
              <span className="brand__sub">FTF trading intelligence</span>
            </span>
          </Link>

          <nav className="topnav">
            <NavLink to="/" end className={({ isActive }) => `topnav__link${isActive ? ' is-active' : ''}`}>
              Items
            </NavLink>
            <NavLink to="/rankings" className={({ isActive }) => `topnav__link${isActive ? ' is-active' : ''}`}>
              Rankings
            </NavLink>
          </nav>

          <a
            className="topbar__meta"
            href="https://www.roblox.com/games/1738581510/Flee-the-Facility"
            target="_blank"
            rel="noreferrer"
          >
            Game Link
          </a>
        </div>
      </header>

      <main className="page-frame">{children}</main>
    </div>
  );
}
